import React, { Fragment } from 'react';
import classnames from 'classnames';

import Link from 'components/atoms/Link';
import Icon from 'components/atoms/Icon';

import IconChevronRight from 'images/icon/chevron-right.inline.svg';

import styles from './index.module.css';

export interface BreadcrumbsItemProperty {
	label: string;
	link?: string;
}

interface BreadcrumbsProperty {
	className?: string;
	items: BreadcrumbsItemProperty[];
}

const Breadcrumbs: React.FC<BreadcrumbsProperty> = ({ className, items }) => (
	<div className={classnames(styles.breadcrumbs, className)}>
		{items.map((item, index) => (
			<Fragment key={item.label}>
				{index !== 0 && <Icon className={styles.chevronRight} src={IconChevronRight} />}
				{item.link ? (
					<Link className={styles.link} to={item.link}>
						{item.label}
					</Link>
				) : (
					<span className={styles.withoutLink}>{item.label}</span>
				)}
			</Fragment>
		))}
	</div>
);

export default Breadcrumbs;
